import styled, { css } from 'styled-components';
import LinkAction from 'components/shared/Routing/components/LinkAction/LinkAction';
import TruncatedGrid from 'components/TruncatedGrid';
import type { ChanelProductVariants, Option } from '../../shared/types';

const Item = styled(LinkAction)<Pick<Option, 'color' | 'isSelected'>>`
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    background-color: ${({ color }) => color};
    box-shadow: ${({ isSelected }) => (isSelected ? css`inset 0 0 0 2px #000, inset 0 0 0 4px #fff` : css`inset 0 0 0 4px #fff`)};
`;

const ShowAllButton = styled.button<{ showAll: boolean }>`
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
    grid-column: -2;
    grid-row: 1;
    border: 0;
    background: 0;

    &:focus {
        outline: 0;
    }

    &::before,
    &:after {
        content: '';
        position: absolute;
        background-color: #000;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    &:before {
        width: 60%;
        height: 2px;
    }

    &:after {
        height: 60%;
        width: 2px;
    }

    ${({ showAll }) =>
        showAll &&
        css`
            grid-column: auto;
            grid-row: auto;

            &:after {
                display: none;
            }
        `}
`;

export default function ColorPalette(props: ChanelProductVariants) {
    const { options } = props;

    return (
        <TruncatedGrid
            cellWidth={43}
            cellHeight={43}
            ToggleButtonRenderer={({ hiddenItemsCount, ...restProps }) => (
                <ShowAllButton type="button" showAll={hiddenItemsCount === 0} {...restProps} />
            )}
        >
            {options.map((option) => (
                <Item
                    key={option.linkAction.url}
                    color={option.color}
                    action={option.linkAction}
                    title={option.label}
                    isSelected={option.isSelected}
                />
            ))}
        </TruncatedGrid>
    );
}
